export default __webpack_public_path__ + "static/media/slide22.64b021c8.jpg";